import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'coApplicantPipe',
    standalone: true
})
export class CoApplicantPipe implements PipeTransform {
    transform(contentKey: string, hasCoApplicant: boolean): string {
        if (hasCoApplicant) {
            return `${contentKey}.together`;
        }

        return `${contentKey}.single`;
    }
}
